import { FC } from "react";
import ConditionSvg from "../../public/icons/Condition.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const ConditionIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><ConditionSvg/></span>;
